import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1stl3gkk5n: FaireBrandEntity = {
  token: "b_1stl3gkk5n",
  type: "brand",
  name: "Bubbsi",
  avatarUrl:
    "https://cdn.faire.com/fastly/9526d1fae28e348f943839e9db1514d39e739a9300fcc9e37fa976f1e2b5f9a5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/95f1b2e0a67f746e8ed8a856694425ba42cd5b152dbdc312e784cb33ec1beb89.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9526d1fae28e348f943839e9db1514d39e739a9300fcc9e37fa976f1e2b5f9a5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/95f1b2e0a67f746e8ed8a856694425ba42cd5b152dbdc312e784cb33ec1beb89.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 7,
  isInsider: true,
  description:
    "Bubbsi is a clean coconut oil line that makes skin & haircare fun for little ones. It was founded by a mom when her newborn had eczema, and she couldn’t find any natural products that actually worked. Our products are over 95% naturally-derived, EU compliant, and deeply moisturizing. Kids adore our squeezable animal bottles, and parents love that they are refillable! With naturally nourishing products that are designed to delight, Bubbsi is bringing snuggly soft skin and loads of giggles to families everywhere.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:24.597Z",
    importedBy: "entity-db-cli",
  },
};
